import { Button, FormLabel, HStack, Input, Stack } from '@chakra-ui/react'
import type { AdditionSportEquipmentTravel, OfferTravel, OfferTravelAddition, PackageItemModel } from 'BrokerTsLib/src/dtos'
import { Insurer } from 'BrokerTsLib/src/enums'
import type { UseFieldArrayRemove } from 'BrokerTsLib/src/rhf'
import { useFieldArray, useFormContext } from 'BrokerTsLib/src/rhf'
import { useEffect } from 'react'
import { Add } from '../../../../../icons'

type SportEquipmentsProps = {
  offer: OfferTravel
  addon: PackageItemModel
}

const getDefaultItem = (addon: PackageItemModel) => {
  const defaultVariant = addon.variants.find(x => x.isDefault) ?? addon.variants[0]

  return {
    riskId: addon.riskId,
    packageItemId: addon.packageItemId,
    variantId: defaultVariant?.id,
    limit: defaultVariant?.defaultLimit?.toString(),
  } as AdditionSportEquipmentTravel
}

function SportEquipments({
  offer,
  addon
}: SportEquipmentsProps) {

  const {
    control,
    setValue
  } = useFormContext<OfferTravelAddition>()

  const name = 'sportEquipments'

  const { append, fields, remove } = useFieldArray({
    control: control,
    name: name
  })

  // vychozi nastaveni hodnot na OfferTravelAddition z OfferPart
  useEffect(() => {
    fields.forEach((item, index) => {
      const part = offer.parts.find(x => x.partId == item.offerPartId)
      if (!part) return

      setValue(`${name}.${index}.riskId`, part.packageItem.riskId)
      setValue(`${name}.${index}.limit`, part.limit?.toString())
      setValue(`${name}.${index}.variantId`, part.packageItemVariantId)
      setValue(`${name}.${index}.offerPartId`, part.partId)
      setValue(`${name}.${index}.packageItemId`, part.packageItem.packageItemId)
    })

    if (fields.length == 0)
      append(getDefaultItem(addon))
  }, [])


  return (
    <HStack gap={8}>
      {fields?.map((item, index) => {
        return <SportEquipmentItem
          key={`${item.offerPartId}_${index}`}
          addon={addon}
          index={index}
          item={item}
          remove={remove}
          offer={offer}
        />
      })}

      {offer.insurerId == Insurer.Direct &&
        <Stack>
          <Button
            variant='outline'
            onClick={() => append(getDefaultItem(addon))}
          >
            <Add color="secondary.500" />
            Další
          </Button>
        </Stack>
      }
    </HStack >
  )
}

export default SportEquipments

type SportEquipmentItemProps = {
  item: AdditionSportEquipmentTravel,
  index: number,
  addon: PackageItemModel,
  remove: UseFieldArrayRemove
  offer: OfferTravel
}

const SportEquipmentItem = ({
  item,
  index,
  remove }: SportEquipmentItemProps) => {

  const name = 'sportEquipments'
  const { register } = useFormContext<OfferTravelAddition>()

  return (
    <Stack key={`${item.offerPartId}_${index}`} alignSelf='start' minW='120px'>
      <FormLabel alignSelf='center'>{index + 1}. ks vybavení</FormLabel>

      <Input
        size='sm'
        placeholder='Popis'
        {...register(`${name}.${index}.description`)} />

      <Button
        size='sm'
        colorScheme='secondary'
        variant='ghost'
        onClick={() => remove(index)}
      >
        Odebrat
      </Button>
    </Stack>
  )
}
